<div class="container text-center">
    <h3>{{'What you want to do?' | translate}}</h3>


    <div class="selector">
        <div class="select col-12 col-md-6  col-lg-4 col-xl-3 select1" (click)="select(Choice.purchase)"
             [ngClass]="{selected: userChoice === Choice.purchase}">
            <div class="tick">
                <img [src]="imgUrl + 'tick.png'">
            </div>
            <div class="icon">
                <img *ngIf="userChoice !== Choice.purchase" [src]="imgUrl + 'cart_1.png'">
                <img *ngIf="userChoice === Choice.purchase" [src]="imgUrl + 'cart_2.png'">
            </div>
            <div class="text" [innerHTML]="'Purchase device, materials or parts'"  translate></div>
        </div>

        <div class="select col-12 col-md-6  col-lg-4 col-xl-3 select2" (click)="select(Choice.service)"
             [ngClass]="{ selected: userChoice === Choice.service}">
            <div class="tick">
                <img [src]="imgUrl + 'tick.png'">
            </div>
            <div class="icon">
                <div class="icon">
                    <img *ngIf="userChoice !== Choice.service" [src]="imgUrl + 'service_1.png'">
                    <img *ngIf="userChoice === Choice.service" [src]="imgUrl + 'service_2.png'">
                </div>
            </div>
            <div class="text">{{'Service the device' | translate}}</div>
        </div>
    </div>


    <div class="jumper" (click)="jumpTpStep3()">
        {{'Just show me all resellers in my country' | translate}} <img class="rotated" [src]="imgUrl + 'svg/back_arrow.svg'" />
    </div>


</div>
